var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"newProject"},[_c('v-btn',{attrs:{"width":"250px","color":"primary"},on:{"click":_vm.newProject}},[_vm._v("Create new project")])],1),_c('project-list')],1)}
var staticRenderFns = []

export { render, staticRenderFns }